/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/bodycopy/bodycopy_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ BODYCOPY : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const BodyCopy = (props) => {
	return (
        <div className={`${sheet.classes.bodycopy} bodycopy`}>
        	{props.children}
        </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default BodyCopy;
